import { GzEnumFilterWebComponent } from '../../gzEnumFilter';
import { html, TemplateResult } from 'lit';
import { query } from 'lit/decorators.js';
import { GzEnumListWebComponent } from '../../gzEnumList';
import { GzOperatingSystemFilterController } from '../controller/GzOperatingSystemFilterController';

export class GzOperatingSystemFilterWebComponent extends GzEnumFilterWebComponent {
  public controller: GzOperatingSystemFilterController;
  public defaultValue: Array<string>;
  public selectedFilterOptions: (number | string)[] = [];

  @query('#multiple-selection-list')
  public enumList!: GzEnumListWebComponent;
  private dependencies: any;

  public injectDependencies(dependencies: any): void {
    if (this.dependencies) {
      return;
    }
    this.dependencies = dependencies;
    this.controller = new GzOperatingSystemFilterController(this.dependencies, this);
  }

  protected renderEnumList(): TemplateResult {
    return html`<gz-enum-list
      id="multiple-selection-list"
      .filterOptions="${this.filterOptions}"
      listTitle="${this.listTitle}"
      .canSelectAll="${this.canSelectAll}"
      allItemsLabel="${this.allItemsLabel}"
      @optionChanged="${this.handleListOptionsChange}"
      class="enum-filter-list"
    ></gz-enum-list>`;
  }
}
